export const SEARCH_PREVIEW_SUGGESTION = 'search-preview-suggestion';
export const CHIP_HEIGHT = 35;
